<div tuiTitle (click)="logout()" class="logout-button menu-button">
    <tui-icon icon="log-out" />
    Logout
</div>
